var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading === true)?_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"loading"},[_c('vue-loading',{attrs:{"type":"spin","color":"white","size":_vm.size}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }